import React from 'react';

import {Collections} from "components";
import Framework from "@beardeddevops/react.framework"
import APPCONFIG from "constants/Config";
import {Button} from "reactstrap";
import {ListItemText, Menu, MenuItem} from '@material-ui/core';
import Types from "../../../../../constants/Types";
import {confirmAlert} from "react-confirm-alert";
import AssignmentLateIcon from '@material-ui/icons/AssignmentLate';
import API from "@beardeddevops/react.api";


const breadcrumbsStatic = [
	{
		name: 'Dashboard',
		url: '/dashboard',
		icon: 'dashboard',
	},
	{
		name: 'Products',
		url: '/inventory',
		icon: 'barcode',
	}
];
class Inventories extends Framework.Components.View {
	constructor(props) {
		super(props);
		this.state.showCheckboxes = false;
		this.state.setSelect = false;
		this.state.dropdownOpen = false;
		this.state.anchorEl = null;
		this.state.selectedItems = null;
		this.state.key = Math.random();
	}

	// This method handles what happens when the user clicks on the Select button.
	handleSelect = () => {
		this.setState(prevState => ({
			showCheckboxes: !prevState.showCheckboxes,
			setSelect: !prevState.setSelect
		}));
	};

	// This method handles when the Actions dropdown is opened.
	handleOpen = (e) => {
		const el = e.currentTarget.name;

		this.setState({
			[el]: e.currentTarget,
		});
	};

	// This method handles when the Actions dropdown is closed.
	handleClose = () => {
		this.setState({
			anchorEl: null,
		});
	};

	// This method is run when a user selects 'Add to Cart' within the Actions dropdown.
	addToCart = ()  => {
		this.state.selectedItems.map((line) => {
			if ((line.quantity && parseInt(line.quantity) <= 0) || !line.quantity) {
				return;
			}
			let item = new API.BuildClass(Types.Checkouts_Items._name, API.RequestType.CREATE);
			item.properties.inventory.value = line.pkey;
			item.object = {
				inventory: line.pkey,
				serial: null,
				quantity: '1',
				taxable: line.skus?.taxable
			}
			item.submit(null, API.RequestType.CREATE)
			this.props.rootState.set({
				session_items_count: this.props.rootState.session_items_count === null ? 1 : 1 + this.props.rootState.session_items_count
			});
		});
	};


	handleDeleteAll = async () => {
		await Promise.all(this.state.selectedItems.map(async (line) => {
			let item = new API.BuildClass(Types.Inventories._name, API.RequestType.READ);
			item.filter = {
				"sku": line.pkey
			};
			const value = await item.submit(null, 'GET_CHECK_EXISTING')
			if (value && value.error !== "No items found.") {
				confirmAlert({
					title: 'Confirm Inventory Deletion',
					message: (value.error + " Do you want to delete this inventory from any existing checkouts?"),
					buttons: [
						{
							label: 'Yes',
							onClick: async () => {
								let model = new API.BuildClass(Types.Inventories._name, API.RequestType.DELETE);
								//for some reason the pkey for an INVENTORIES DELETE needs to be a SKU...
								model.object.pkey = line.sku;
								await model.submit(null, API.RequestType.DELETE);
								this.props.rootState.triggerAction('getUserInformation');
								this.setState({setSelect: false, key: Math.random(), anchorEl: false, showCheckboxes: false})
							}
						},
						{
							label: 'Cancel',
							onClick: () => {
							}
						}
					]
				});
			} else {
				let model = new API.BuildClass(Types.Inventories._name, API.RequestType.DELETE);
				//for some reason the pkey for an INVENTORIES DELETE needs to be a SKU...
				model.object.pkey = line.sku;
				await model.submit(null, API.RequestType.DELETE);
				this.props.rootState.triggerAction('getUserInformation');
				this.setState({setSelect: false, key: Math.random(), anchorEl: false, showCheckboxes: false})
			}
		}))
	}

	// This method grabs the array selectedItems from Collections\Inventories to use for actions within the Actions
	// dropdown.
	handleData = (data) => {
		this.setState({
			selectedItems: data
		});
	};

	render() {
		const { anchorEl } = this.state;
		const { roles } = this.props.rootState;

		return (
			<div className="container-fluid">
				<Framework.Components.PageBar breadcrumbs={breadcrumbsStatic} history={this.props.history}>
					{this.state.setSelect ? (
						<div style={{display: "inline-block"}}>
							<Button
								name="anchorEl"
								aria-owns={anchorEl ? 'action-menu' : null}
								aria-haspopup="true"
								onClick={this.handleOpen}
								size={'sm'}
								color={'primary'}
							>
								<AssignmentLateIcon/>
								<span style={{margin: '0 10px'}}>Actions</span>
								<i className={'fa fa-angle-down'}/>
							</Button>
						</div>
					) : null}
					<Button size={"sm"} color="secondary"
					        onClick={this.handleSelect}>{!this.state.setSelect ? "Select" : "Cancel"}
					</Button>

					<Menu
						id="action-menu"
						anchorEl={anchorEl}
						open={Boolean(anchorEl)}
						onClose={this.handleClose}
						getContentAnchorEl={null}
						anchorOrigin={{horizontal: 'right', vertical: 'bottom'}}
						transformOrigin={{horizontal: 'right', vertical: 'top'}}
					>
						<div>
							<MenuItem onClick={this.addToCart}>
								<ListItemText inset primary="Add to Cart"></ListItemText>
							</MenuItem>
							{(roles === "10" || roles === 4) && (
								<>
									<MenuItem onClick={async () => {
										await this.handleDeleteAll();
									}}>
										<ListItemText inset primary="Delete All"></ListItemText>
									</MenuItem>
								</>
							)}
						</div>
					</Menu>
				</Framework.Components.PageBar>
				<Collections.Inventories
					key={this.state.key}
					history={this.props.history}
					reloadParent={this.props.reloadParent}
					showCheckboxes={this.state.showCheckboxes}
					sendData={this.handleData}
				/>

			</div>
		);
	}
}
export default Framework.Components.withRootState(Inventories);
